export enum CUSTOMER_SOURCE {
  INVOICE = 'invoice',
  APPOINTMENT = 'appointment',
}
